<template>
  <div id="layout">
    <sidebarComponent id="sidebarComponent" />
    <div id="main-content">
      <headerComponent id="headerComponent" />
      <div id="content">
        <router-view />
      </div>
    </div>
    <footerComponent id="footerComponent" />
  </div>
</template>

<script>
import HeaderComponent from './components/header.vue';
import SidebarComponent from './components/sidebar.vue';
import FooterComponent from './components/Footer.vue';

export default {
  components: {
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
  },
};
</script>

<style>
#layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#main-content {
  flex: 1;
  display: flex;
  margin-top: 60px; /* Sesuaikan dengan tinggi header */
}

#headerComponent {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 10;
  background-color: #ffffff; /* Latar belakang putih untuk kontras */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

#headerComponent .search-bar {
  flex: 1;
  margin: 0 10px;
}

#sidebarComponent {
  width: 250px;
  flex-shrink: 0;
  position: fixed;
  top: 60px; /* Offset by the header height */
  bottom: 0;
  background-color: #ffffff; /* Tambahkan latar belakang untuk kejelasan */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  #sidebarComponent {
    width: 200px; /* Kurangi lebar sidebar di layar kecil */
  }
}

@media (max-width: 576px) {
  #sidebarComponent {
    position: absolute;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    bottom: auto;
    z-index: 20; /* Pastikan sidebar berada di atas konten */
  }

  #content {
    margin-left: 0; /* Konten penuh tanpa sidebar */
  }
}

#content {
  flex: 1;
  padding: 20px;
  margin-left: 250px; /* Offset to match sidebar width */
  overflow: auto;
  background-color: #f9f9f9; /* Latar belakang terang untuk membedakan */
  border-radius: 8px; /* Tambahkan sudut membulat agar lebih modern */
}

@media (max-width: 768px) {
  #content {
    padding: 15px;
    margin-left: 200px; /* Sesuaikan dengan sidebar yang lebih kecil */
  }
}

@media (max-width: 576px) {
  #content {
    margin-left: 0;
    padding: 10px;
  }
}
#footerComponent {
  text-align: center;
  width: calc(100% - 250px); /* Kurangi lebar sidebar agar sesuai dengan konten */
  margin-left: 250px; /* Sama seperti margin konten */
  background-color: #f1f1f1; /* Latar belakang untuk pemisah */
  padding: 10px;
  position: relative;
  font-size: 14px;
  color: #666; /* Warna teks lebih lembut */
}

@media (max-width: 768px) {
  #footerComponent {
    width: calc(100% - 200px); /* Sesuaikan dengan sidebar yang lebih kecil */
    margin-left: 200px;
  }
}

@media (max-width: 576px) {
  #footerComponent {
    width: 100%;
    margin-left: 0;
  }
}

</style>
